import React from 'react';
import { PageHeader, Space } from 'antd';
import map from 'lodash/map';

function ContentPageHeader(props) {
  const { title, subTitle, onBack, extra, border } = props;

  return (
    <div
      className={`content-page-header ${
        border ? 'content-page-header-border' : ''
      }`}
    >
      <PageHeader
        onBack={onBack}
        title={
          <Space>
            {map(title, (t, index) => {
              return <span key={index}>{t}</span>;
            })}
          </Space>
        }
        subTitle={subTitle}
        extra={extra}
      />
    </div>
  );
}

export default ContentPageHeader;
